/**
 * @file 权限校验
 */
 import store from '@/vuex/store';

 export async function getUserAuth() {
    if (!store.state.env.userInfo.token) {
        const tk = localStorage.getItem('tk');
        tk && store.commit('SET_USER_INFO', {token: tk});
    }

    if (store.getters['zft/menuList'].length === 0) {
         try {
             await store.dispatch('zft/getMenuList');
         }
         catch (e) {
             throw e;
         }
     }

     // if (!store.getters['tabbar/userInfo'].pid) {
     //     return false;
     // }



     return true;
 }
